var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.7402V4.67019C22.5 3.47019 21.52 2.58019 20.33 2.68019H20.27C18.17 2.86019 14.98 3.93019 13.2 5.05019L13.03 5.16019C12.74 5.34019 12.26 5.34019 11.97 5.16019L11.72 5.01019C9.94 3.90019 6.76 2.84019 4.66 2.67019C3.47 2.57019 2.5 3.47019 2.5 4.66019V16.7402C2.5 17.7002 3.28 18.6002 4.24 18.7202L4.53 18.7602C6.7 19.0502 10.05 20.1502 11.97 21.2002L12.01 21.2202C12.28 21.3702 12.71 21.3702 12.97 21.2202C14.89 20.1602 18.25 19.0502 20.43 18.7602L20.76 18.7202C21.72 18.6002 22.5 17.7002 22.5 16.7402Z",
    stroke: "#EC42B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.49023V20.4902V5.49023Z",
    fill: "#EC42B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.49023V20.4902",
    stroke: "#EC42B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.49023H6H8.25Z",
    fill: "#EC42B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.49023H6",
    stroke: "#EC42B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4902H6",
    stroke: "#EC42B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ec77bcd39507284bbf149b37dd8e4642.svg";
export { ForwardRef as ReactComponent };